import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {InventoryItem, InventoryState, Lead, Room, Service} from '@/store/types'
import ServiceModel from '@/classes/ServiceModel'
import axios from 'axios'
import LeadRoomInventoryModel from '@/classes/LeadRoomInventoryModel'

type InventoryGetter = GetterTree<InventoryState, any>
type InventoryMutation = MutationTree<InventoryState>
type InventoryAction = ActionTree<InventoryState, any>

const state: InventoryState = {
  inventory: [],
  itemTypes: [],
  addedItem: null,
  activeItem: null,
  activeItemType: null,
  showInventoryAddedItem: false,
  activeItemTypeQuantity: 1,
  addedItemTransition: false,
}

const getters: InventoryGetter = {
  inventory: (state) => state.inventory,
  itemTypes: (state) => state.itemTypes,
  roomInventory: (state, getters, rootState) => state.inventory
  .filter((i) => rootState.rooms.activeRoomId === i.lead_room_id),
  totalVolume: (state) => state.inventory.reduce((carry: number, item: InventoryItem) => {
    return carry += item.volume * item.quantity
  }, 0),
  addedItem: (state) => state.addedItem,
  activeItem: (state) => state.activeItem,
  activeItemType: (state) => state.activeItemType,
  showInventoryAddedItem: (state) => state.showInventoryAddedItem,
  activeItemTypeQuantity: (state) => state.activeItemTypeQuantity,
  addedItemTransition: (state) => state.addedItemTransition,
}

const mutations: InventoryMutation = {
  setInventory: (state, inventory) => {
    state.inventory = inventory
  },
  setItemTypes: (state, itemTypes) => {
    state.itemTypes = itemTypes
  },
  setInventoryFromRooms: (state, rooms = []) => {
    state.inventory = []
    rooms.forEach((room: Room) => {
      state.inventory = state.inventory.concat(room.inventory)
    })
  },
  removeRoomInventory: (state, roomId) => {
    state.inventory = state.inventory.filter((i) => i.lead_room_id !== roomId)
  },
  addItem: (state, item) => {
    state.inventory.unshift(item)
  },
  editItem: (state, item) => {
    state.inventory = state.inventory.map((i) => i.id === item.id ? item : i)
  },
  removeItem: (state, item) => {
    state.inventory = state.inventory.filter((i) => i.id !== item.id)
  },
  setActiveItem: (state, item) => {
    state.activeItem = Object.assign({}, item)
  },
  setAddedItem: (state, item) => {
    state.addedItem = Object.assign({}, item)
  },
  setAddedItemTransition: (state, payload) => {
    state.addedItemTransition = payload
  },
  resetActiveItem: (state) => {
    state.activeItem = null
  },
  setActiveItemType: (state, itemType) => {
    state.activeItemType = Object.assign({}, itemType)
  },
  resetActiveItemType: (state) => {
    state.activeItemType = null
  },
  setInventoryAddedItem: (state, payload) => {
    state.showInventoryAddedItem = payload
  },
  setActiveItemTypeQuantity: (state, payload) => {
    state.activeItemTypeQuantity = payload
  },
}

const actions: InventoryAction = {
  getItemTypes: ({commit}) => {
    return new Promise((resolve, reject) => {
      axios.get('inventory?sort_by=most_used').then((response) => {
        commit('setItemTypes', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addRoomItem: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('lead-room-inventory', payload).then((response) => {
        commit('addItem', response.data.data)
        dispatch('syncTaskInventory')
        dispatch('syncServices')
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addCustomRoomItem: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('lead-room-inventory-custom', payload).then((response) => {
        commit('addItem', response.data.data)
        dispatch('syncTaskInventory')
        dispatch('syncServices')
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  editRoomItem: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      axios.put(`lead-room-inventory/${payload.id}`, payload).then((response) => {
        commit('editItem', response.data.data)
        dispatch('syncTaskInventory')
        dispatch('syncServices')
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  removeRoomItem: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      axios.delete(`lead-room-inventory/${payload.id}`).then((response) => {
        commit('removeItem', payload)
        dispatch('syncTaskInventory')
        dispatch('syncServices')
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  syncInventoryFullPack: ({commit, rootState}) => {
    // TODO API Sync
    let inventory = state.inventory
    const fullPack = rootState.services.services.find((s: Service) => s.name === ServiceModel.fullPack.name)
    if (fullPack !== undefined) {
      inventory = inventory.map((i) => {
        i.packed_by = LeadRoomInventoryModel.PACKED_BY.MOVERS
        return i
      })
    } else {
      // TODO API Sync ???
      // TODO Reset to defaults (uncomment and api sync)
      inventory = inventory.map((i) => {
        i.packed_by = i.is_box ? LeadRoomInventoryModel.PACKED_BY.CUSTOMER : LeadRoomInventoryModel.PACKED_BY.MOVERS
        return i
      })
    }
    commit('setInventory', inventory)
  },
  openInventoryAddedItem: ({commit, dispatch}) => {
    setTimeout(() => {
      commit('setInventoryAddedItem', true)
      dispatch('closeInventoryAddedItem')
    }, 300)
  },
  closeInventoryAddedItem: ({commit}) => {
    setTimeout(() => {
      commit('setInventoryAddedItem', false)
    }, 2000)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
